import { atom } from 'jotai'

import { type ShipmentOrdersListExEntity } from '@/libs/api'

/**
 * 配送依頼一覧で選択中の行と、その選択が有効な文脈(拠点・テナント)
 *
 * ページング・ソート・検索条件の変更は TanStack Router の matchId(loaderDeps を
 * 含む search の JSON がキーに乗る)が変わるため、ShipmentOrdersTable はその都度
 * 再マウントされる。useState では再マウントのたびに選択が消えてしまうため、
 * 再マウントを跨いで生き残るモジュールスコープの atom に選択を保持する。
 *
 * dcId・tenantKey が変わった場合は選択を持ち越したくない(誤操作防止・テナント間の
 * 漏洩防止)ため、「その選択がどの文脈で行われたか」を orders と一緒に保持し、
 * 参照側で現在の文脈と突き合わせて判定できるようにしている。
 */
export type ShipmentOrdersSelection = {
  /** 選択が有効な拠点。これが変わったら選択は破棄する */
  dcId: number | undefined
  /** 選択が有効なテナント。テナントを跨いだ選択の持ち越しを防ぐ */
  tenantKey: string | undefined
  orders: ShipmentOrdersListExEntity[]
}

export const initialShipmentOrdersSelection: ShipmentOrdersSelection = {
  dcId: undefined,
  tenantKey: undefined,
  orders: []
}

export const shipmentOrdersSelectionAtom = atom<ShipmentOrdersSelection>(
  initialShipmentOrdersSelection
)

shipmentOrdersSelectionAtom.debugLabel = 'shipmentOrdersSelectionAtom'
